const c = (val: number) => {
    if (val < 10) {
        return `0${val}`;
    }
    return val.toString();
};

export function formatTimeToHumanReadable(
    timeInSeconds: number,
    { alwaysShowHours }: { alwaysShowHours: boolean } = { alwaysShowHours: false },
): string {
    const sec = Math.max(0, timeInSeconds);
    const h = Math.floor(sec / 3600);
    const hSec = h * 3600;
    const mSec = sec - hSec;
    const m = Math.floor(mSec / 60);
    const s = Math.floor(mSec - m * 60);

    if (h || alwaysShowHours) {
        return `${h}:${c(m)}:${c(s)}`;
    }
    return `${m}:${c(s)}`;
}
